<div class="tp-page tp-page--narrow">
  <tp-page-header title="Página no encontrada"></tp-page-header>
  <section class="tp-card not-found">
    <tp-empty-state
      icon="travel_explore"
      title="La dirección que abriste no existe"
      message="Puede que el enlace esté mal escrito o que la página se haya movido."
    >
      <a action mat-flat-button routerLink="/welcome">Ir al inicio</a>
    </tp-empty-state>
  </section>
</div>
